// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"2d0f18962b112b28","660":"aa1051e28261210d"}[chunkId] + ".css";
};